import { useState, lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from '@/components/Layout';
import Login from '@/pages/Login';
import { getSessionToken, setSessionToken, setSessionUser, clearSession, auth } from '@/lib/api';

const Dashboard = lazy(() => import('@/pages/Dashboard'));
const ManualDashboard = lazy(() => import('@/pages/ManualDashboard'));
const Leads = lazy(() => import('@/pages/Leads'));
const ManualLeads = lazy(() => import('@/pages/ManualLeads'));
const Visitors = lazy(() => import('@/pages/Visitors'));
const Team = lazy(() => import('@/pages/Team'));

function PageFallback() {
  return (
    <div className="flex min-h-svh items-center justify-center text-sm text-muted-foreground">
      Loading…
    </div>
  );
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!getSessionToken());

  const handleLogin = async (email: string, password: string): Promise<string | null> => {
    const res = await auth.login(email, password);
    if (res.status === 'success' && res.token) {
      setSessionToken(res.token);
      if (res.user) setSessionUser(res.user);
      setIsAuthenticated(true);
      return null;
    }
    return res.message || 'Login failed';
  };

  const handleLogout = () => {
    auth.logout();
    clearSession();
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Layout onLogout={handleLogout}>
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/manual" element={<ManualDashboard />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/manual-leads" element={<ManualLeads />} />
          <Route path="/visitors" element={<Visitors />} />
          <Route path="/team" element={<Team />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}

export default App;
